import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { Flex, Box } from 'reflexbox';
import {
  Text,
} from 'rebass';

import {
  classes,
  races,
  hasDoubleOnUseEquipped,
} from 'shared/character';

import TalentStrip from 'frontend/components/Simbot/TalentStrip';
import GearStrip from 'frontend/components/Simbot/GearStrip';
import {
  If,
} from 'frontend/components';


const CharacterInfo = ({ character, gear }) => {
  if (!character) {
    return null;
  }

  const activeLoadout = _.find(character.talentLoadouts, { active: true });
  const talents = activeLoadout?.talents;

  const specName = talents?.specName;

  const iconSize = 18;

  const showDoubleOnUseWarning = hasDoubleOnUseEquipped(character);

  return (
    <Box>
      <Box justify="flex-start" mb={1}>
        <Text>
          {character.level}
          {' '}
          {_.get(_.find(races, { id: character.race }), 'name', '')}
          {' '}
          {specName}
          {' '}
          {_.get(_.find(classes, { id: character.class }), 'name')}
        </Text>
      </Box>
      <Flex wrap align="flex-start" mr={1}>
        <GearStrip
          size={iconSize}
          equippedGear={gear}
          classId={character.class}
          specName={specName}
          showEmptySlots
          hideCraftingQuality
          wrap
        />
        <If
          condition={showDoubleOnUseWarning}
          then={() => (
            <Text small ml={1}>
              <a
                href="https://support.raidbots.com/article/23-how-do-sims-handle-double-on-use-trinkets"
                target="_blank"
                rel="noopener noreferrer"
              >
                How are double &quot;On Use&quot; trinkets handled?
              </a>
            </Text>
          )}
        />
      </Flex>
      <If
        condition={talents}
        then={() => (
          <Box mt={1}>
            <TalentStrip
              talents={talents}
              specId={talents.specId}
              level={character.level}
              size={iconSize}
            />
          </Box>
        )}
      />
    </Box>
  );
};

CharacterInfo.propTypes = {
  character: PropTypes.object,
  gear: PropTypes.object,
};

CharacterInfo.defaultProps = {
  character: null,
  gear: null,
};

export default CharacterInfo;
